export default __webpack_public_path__ + "static/media/point_site_man.c963a08b.png";